import FitnessTypes from './fitness-types';

export default FitnessTypes;
